// extracted by mini-css-extract-plugin
export default {"fontSizeList":"8,12,14,16,18,24","lineHeightList":"12,16,18,20,24,32"};